export const theme = {
  palette: {
    primary: "#B29B84",
    light: "#F5F5F5",
    stroke: "#060606",
    small: "#E2E2E2",
    large: "#595D62",
    error: "#e74c3c",
    default: "#FFFFFF"
  },
  breakpoints: {
    xxxl: "1949.9px",
    xxl: "1799.9px",
    xl: "1499.9px",
    xlg: "1399.9px",
    lg: "1199.9px",
    md: "991.9px",
    sm: "767.9px",
    xs: "575.9px",
    xss: "373.9px",
  },
};